import { takeEvery } from 'redux-saga/effects';
import { onOpenModal } from './on-open-modal';

export function* openModalSaga({ modals }) {
  yield takeEvery('OPEN_MODAL', onOpenModal, modals);
}
